import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

import AttachedFilesBox from '../Shared/AttachedFilesBox'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'

import { updateInputs } from '../../actions/usuarios'

class GruposPermisos extends Component {
	render() {
        const { usuario } = this.props
        if (!usuario) return null

		return (
            <div style={{ height: '100%' }}>
                <div className="row" style={{ height: '100%' }}>
                    <div className="col-md-6" style={{ height: '100%' }}>
                        <div style={{ height: '100%', overflowX: 'hidden', border: '1px solid #ddd' }}>
                            <table className="table table-bordered table-condensed table-striped">
                                <thead>
                                    <tr>
                                        <th style={{ width: '20px' }}></th>
                                        <th>Grupos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        usuario.get('grupos').map((a, b) => {
                                            return (
                                                <tr key={`tr24[${a.get('id')}]`} className={ a.get('selected') ? 'info' : '' }>
                                                    <td><input id={`tr23[${a.get('id')}]`} type="checkbox" checked={ a.get('selected') } onChange={ e => this.props.updateInputs(`modalCreate.data.grupos.${b}.selected`, e.target.checked) } /></td>
                                                    <td><label className="htmlFor" htmlFor={`tr23[${a.get('id')}]`}>{ a.get('descripcion') }</label></td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div className="col-md-6" style={{ height: '100%' }}>
                        <div style={{ height: '100%', overflowX: 'hidden', border: '1px solid #ddd' }}>
                            <table className="table table-bordered table-condensed table-striped">
                                <thead>
                                    <tr>
                                        <th style={{ width: '20px' }}></th>
                                        <th>Permisos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        usuario.get('permisos').map((a, b) => {
                                            return (
                                                <tr key={`tr23[${a.get('id')}]`} className={ a.get('selected') ? 'info' : '' }>
                                                    <td><input id={`tr23[${a.get('id')}]`} type="checkbox" checked={ a.get('selected') } onChange={ e => this.props.updateInputs(`modalCreate.data.permisos.${b}.selected`, e.target.checked) } /></td>
                                                    <td><label className="htmlFor" htmlFor={`tr23[${a.get('id')}]`}>{ a.get('descripcion') }</label></td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        usuario: state.usuarios.getIn(['modalCreate', 'data'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GruposPermisos)


// WEBPACK FOOTER //
// ./src/components/Usuarios/GruposPermisos.jsx